




































import { defineComponent, computed, ref, watch } from '@vue/composition-api';
import { ChevronLeftIcon } from 'tdesign-icons-vue';
import useYufuLogin from '@/renderer/components/login/compositions/useYufuLogin';

import SelectInput from './SelectInput.vue';

export default defineComponent({
  components: { ChevronLeftIcon, SelectInput },
  props: { show: { type: Boolean } },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { tenantId, corpId, tenantIdList, corpIdList, tenantType, methods: loginMethods } = useYufuLogin();
    const confirmDisabled = computed(
      () => (tenantType.value === 'tenantName' && !tenantId.value) || (tenantType.value === 'corpId' && !corpId.value),
    );

    const methods = {
      cancel() {
        innerShow.value = false;
        context.emit('cancel');
      },
    };

    // 企业id不支持空格
    watch(tenantId, val => {
      tenantId.value = `${val}`.replace(/\s/g, '').replace(/\./g, '');
    });
    watch(corpId, val => {
      corpId.value = `${val}`.replace(/\s/g, '').replace(/\./g, '');
    });
    return {
      innerShow,
      tenantType,
      tenantId,
      corpId,
      tenantIdList,
      corpIdList,
      confirmDisabled,
      ...methods,
      ...loginMethods,
    };
  },
});
